import classNames from "classnames";
import {
  FieldMessage,
  FieldValue,
  fieldControlClass,
  fieldDescribedBy,
  helpTextId,
} from "./FieldValue";
import { BooleanFieldProps } from "./BooleanField.types";

export function BooleanField({
  label,
  name,
  value,
  onChange,
  disabled,
  layout = "inline",
  error,
  className = "",
  helpText,
}: BooleanFieldProps) {
  const input = (
    <input
      id={name}
      aria-describedby={fieldDescribedBy(name, helpText, error)}
      aria-invalid={error ? true : undefined}
      name={name}
      type="checkbox"
      role="switch"
      className={fieldControlClass("form-check-input", error)}
      checked={!!value}
      onChange={(event) => onChange(event.target.checked)}
      disabled={disabled}
    />
  );

  if (layout === "stacked") {
    return (
      <FieldValue label={label} htmlFor={name} helpText={helpText} error={error} className={className}>
        <div className="form-check form-switch">{input}</div>
      </FieldValue>
    );
  }

  return (
    <div
      className={classNames("field-value form-check form-switch", className)}
    >
      {input}
      <label className="form-check-label" htmlFor={name}>
        {label}
      </label>
      {helpText && (
        <p
          id={helpTextId(name)}
          className="form-text small text-body-secondary mb-0"
        >
          {helpText}
        </p>
      )}
      <FieldMessage name={name} error={error} />
    </div>
  );
}
